import { Avatar, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box, Skeleton } from 'native-base';
import React from 'react';

import { SentOrderDetailResponseNormalized } from '../../../../../store/rateManagement/selector';

export declare namespace CardItemErrorTypes {
  export interface Props {
    item: Utils.ArrayElement<SentOrderDetailResponseNormalized['invalidCustomers']>;
    isLoading?: boolean;
    currentStatus: JSX.Element | undefined;
  }
}

export const CardItemError: React.FC<CardItemErrorTypes.Props> = ({
  item,
  isLoading,
  currentStatus,
}) => {
  return (
    <VStack
      shadow={1}
      marginBottom={Spacing['inset.xs']}
      borderRadius={Spacing['inline.nano']}
      width="100%"
      justifyContent="space-between"
      paddingX={Spacing['inset.sm']}
      paddingY={Spacing['inset.sm']}
      background={Color['neutral.white']}>
      {isLoading ? (
        <VStack width="100%">
          <Skeleton
            pb={Spacing['inline.nano']}
            pr={Spacing['inline.nano']}
            width="100%"
            testID="test-skeleton"
            borderRadius="sm"
            height="50px"
          />
          <Skeleton
            pr={Spacing['inline.nano']}
            width="100%"
            testID="test-skeleton"
            borderRadius="sm"
            height="75px"
          />
        </VStack>
      ) : (
        <>
          <HStack paddingBottom={Spacing['inset.xs']} alignItems="center" flex={1}>
            <Box alignItems="center" mr={Spacing['inset.xs']}>
              {currentStatus}
            </Box>

            <Box alignItems="center" mr={Spacing['inset.xs']}>
              <Avatar
                testId="table-customer-suitability"
                bgColor={'linechart.principal'}
                initials={item.customerNameNormalized}
                textColor={'neutral.white'}
              />
            </Box>

            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              fontSize={Typography['fontsize.md']}
              fontWeight={Typography['fontweight.semibold']}
              flex={1}
              textAlign="start">
              {item.customerNameNormalized}
            </Text>
          </HStack>

          <HStack justifyContent="space-between">
            <VStack>
              <Text fontSize={Typography['fontsize.xs']} pb={Spacing['inline.nano']}>
                Descrição
              </Text>
              {item.processErrorDescription?.map((error, index) => (
                <Text
                  fontSize={Typography['fontsize.md']}
                  key={index.toString()}
                  mr={Spacing['inset.nano']}>
                  {error.errorMessageAlias}
                </Text>
              ))}
            </VStack>
          </HStack>
        </>
      )}
    </VStack>
  );
};
